export const reviewAreaStyleProps = {
    marginTop: '2rem',
    alignItems: 'left',
    height: '13rem',
    maxWidth: '100%',
};

export const reviewAreaTitleStyleProps = {
    padding: 'none',
    fontSize: '1.25rem',
};

export const reviewStyleProps = {
    marginY: '1rem',
};

export const reviewerStyleProps = {
    color: 'gray',
    fontSize: '0.75rem',
    fontWeight: 'semibold',
};

export const reviewTextStyleProps = {
    fontSize: '1rem',
    fontWeight: 'light',
    minWidth: '18rem',
};
